import { IRequest, IRequestError } from "../interfaces/authentication.interface";
import { IResources } from "../interfaces/resources.interface";
import { strapiRequest } from "./requests.service";

export const getResources = async (
    locale: string,
    countryIsoCode?: string
): Promise<IRequest<IResources>> => {
    try {
        const query = `
            query ResourcesAndServices(
                $filters: ResourceAndServiceFiltersInput
                $locale: I18NLocaleCode
                ) {
                resourcesAndServices(filters: $filters, locale: $locale) {
                    country {
                        name
                    }
                    resources {
                        title
                        subsections {
                            subtitle
                            resources {
                                type
                                description
                                link {
                                    href
                                    target
                                    text
                                }
                            }
                        }
                    }
                }
            }`;

        const variables = {
            filters: {
                country: {
                    isoCode: {
                        eq: countryIsoCode ? countryIsoCode : null
                    }
                }
            },
            status: "PUBLISHED",
            locale
        };

        const response = await strapiRequest.post<{ data: { resourcesAndServices: IResources[] } }>(
            `/graphql`,
            {
                operationName: "ResourcesAndServices",
                query,
                variables
            }
        );

        return { success: true, data: response.data.data.resourcesAndServices[0] ?? {resources: []} };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
